import React, { Dispatch, SetStateAction, useState } from "react";
import {useTranslation} from "react-i18next";
import Select from "@awsui/components-react/select";
import League from "model/League";
import { useQuery } from "react-query";
import getLeagues from "api/getLeagues";
import Flashbar from "@awsui/components-react/flashbar";
import Spinner from "@awsui/components-react/spinner";
import { OptionDefinition } from "@awsui/components-react/internal/components/option/interfaces";
import {useAuth} from "hooks/useAuth";


interface LeaguesSelectProps {
    selectedLeague: League | undefined;
    setSelectedLeague: Dispatch<SetStateAction<League | undefined>>;
}

const LeaguesSelect: React.FC<LeaguesSelectProps> = (props) => {

    const {t} = useTranslation(["common", "errors"]);
    const [{user}] = useAuth();
    const [selectedOption, setSelectedOption] = useState({});

    const {
        isLoading: leaguesIsLoading,
        data: leagues,
        error: getLeaguesError
    } = useQuery<League[], Error>("getLeagues", () => getLeagues(user?.token));

    const changeLeague = (selected: OptionDefinition, leagues: League[]) => {
        setSelectedOption(selected);
        const selectedLeague: League = leagues?.filter(league => (
            league.leagueId === parseInt(selected.value || "", 10)
        ))[0];
        props.setSelectedLeague(selectedLeague);
    };

    if (getLeaguesError) {
        return (
            <Flashbar
                items={[{
                    header: t("errors:leaguesLoad"),
                    type: "error",
                    content: t("common:errors.tryReload"),
                    dismissible: false,
                }]}
            />
        );
    }

    if (leaguesIsLoading || selectedOption === undefined) {
        return (
            <Spinner size="big" />
        );
    }

    return (
        <Select
            selectedOption={selectedOption}
            onChange={({ detail }) => (
                changeLeague(detail.selectedOption, leagues || [])
            )}
            options={leagues?.map(league => ({
                label: league.name,
                value: `${league.leagueId}`
            }))}
            selectedAriaLabel={t("common:common.selected")}
        />
    );
};

export default LeaguesSelect;
